import { MOBILE_MAX_WIDTH } from '@/domains/productDiscovery/HeaderLeonidas/constants';

export const isMobile = () =>
  window
    ? window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH} )`).matches
    : false;
